import { render, staticRenderFns } from "./SelfServiceCancelDialog.vue?vue&type=template&id=65b2cd5a&scoped=true"
import script from "./SelfServiceCancelDialog.vue?vue&type=script&lang=js"
export * from "./SelfServiceCancelDialog.vue?vue&type=script&lang=js"
import style0 from "./SelfServiceCancelDialog.vue?vue&type=style&index=0&id=65b2cd5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2cd5a",
  null
  
)

export default component.exports